import { Component, inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { DailyReportService } from '../../../../daily-report.service';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../../../../../../../../../shared/services';
import { IssueService } from '../../../../../../../../../issue/issue.service';
import {
  IssueWorkflowChange,
} from '../../../../../../../../../../shared/components/issue-workflow/issue-workflow-panel/issue-workflow-panel.component';
import { IssueDetailsFormComponent } from '../issue-details-form/issue-details-form.component';
import { IssueWorkflowIssue } from '../../../../../../../../../../shared/helpers/issue-workflow';

@Component({
    selector: 'app-issue-details-wrapper',
    templateUrl: './issue-details-wrapper.component.html',
    styleUrls: ['./issue-details-wrapper.component.scss'],
    standalone: false
})
export class IssueDetailsWrapperComponent implements OnInit, OnDestroy {
  @ViewChild(IssueDetailsFormComponent) issueForm: IssueDetailsFormComponent;
  @Input() data: any;
  disableOptionMenu = false;
  hideDeleteOption = false;
  isMarkerClick = false;
  /** The tab of the contractor-workflow panel: 0 Details, 1 Discussion. Always 0 off the workflow. */
  workflowTabIndex = 0;
  /** True while a contractor-workflow action is picked: its Submit stands in for the Save bar. */
  workflowActionActive = false;
  /** False on the contractor workflow when the user cannot edit the issue. */
  saveBarVisible = true;
  name = '';
  private readonly onDestroy: Subject<any> = new Subject<any>();
  private readonly issueService = inject(IssueService);

  constructor(
    private dailyReportService: DailyReportService,
    public authService: AuthService,
  ) {

    this.dailyReportService.disableOptionMenu
      .pipe(takeUntil(this.onDestroy))
      .subscribe(disableOptionMenu => {
        this.disableOptionMenu = disableOptionMenu;
      });

    this.dailyReportService.hideDeleteOption
      .pipe(takeUntil(this.onDestroy))
      .subscribe(hideDeleteOption => {
        this.hideDeleteOption = hideDeleteOption;
      });
  }

  ngOnInit() {
    this.name = this.getName(this.data);
    this.isMarkerClick = !!(this.data && this.data.isMarkerClick);
  }


  /**
   * A contractor-workflow action went through (only raised on a project with
   * issue_workflow_enabled). The panel stays open on the updated issue; the
   * lists behind it are refreshed the way a save refreshes them, without
   * closing the panel.
   */
  /**
   * The workflow panel loaded the issue from the API (only on a project with
   * issue_workflow_enabled). The daily report's copy has no creator and no
   * scope entity; the form and the Save bar need both to decide editability.
   */
  onWorkflowIssueLoaded(issue: IssueWorkflowIssue) {
    this.issueForm?.applyWorkflowIssue(issue);
  }

  onWorkflowChange(change: IssueWorkflowChange) {
    const issue = change?.issue;
    if (!issue) {
      return;
    }
    this.data = {
      ...this.data,
      status: issue.status,
      internal: issue.internal,
      comment: issue.comment,
      closed_at: issue.closed_at ?? null,
      closedBy: issue.closedBy ?? null,
      updated_at: issue.updated_at,
    };
    this.name = this.getName(this.data);
    this.issueForm?.applyWorkflowChange(this.data);
    this.issueService.fetchIssuesList.next(true);
    this.dailyReportService.fetchDailyReportById.next({ fromDialog: true });
  }

  getName(data) {
    const name = `${data?.closedBy?.first_name} ${data?.closedBy?.last_name}`;
    const account = this.authService.getCurrentUser();
    const accountHolderName = `${account?.first_name} ${account?.last_name}`;

    if (name === accountHolderName) {
      return 'You';
    } else {
      return name;
    }
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
